import { hmsAPI } from '@/api'

export const deleteSettings = () => hmsAPI.delete('/settings/')
export const getSettings = () => hmsAPI.get('/settings/')
export const setSettings = data => hmsAPI.post('/settings/', data)
export const updateSettings = data => hmsAPI.put('/settings/', data)
